/**
 * QuestionCard — single-question wrapper with calm visual treatment.
 * Renders prompt + optional helper; delegates input to QuestionRenderer.
 */
import QuestionRenderer from "./QuestionRenderer";

export default function QuestionCard({ question, value, onChange, index }) {
  return (
    <section
      className="kcis-assessment-card p-6 sm:p-8 kcis-fade-in"
      data-testid={`question-card-${question.id}`}
    >
      <div className="mb-5 flex items-start gap-3">
        <span className="kcis-assessment-overline mt-1 shrink-0">Q{index + 1}</span>
        <div className="min-w-0">
          <h3 className="kcis-assessment-display text-xl sm:text-2xl leading-snug">
            {question.prompt}
          </h3>
          {question.helper && question.type !== "multi-select" && (
            <p className="mt-2 text-sm text-slate-500">{question.helper}</p>
          )}
          {question.optional && (
            <p className="mt-1 text-xs text-slate-400">Optional</p>
          )}
        </div>
      </div>
      <QuestionRenderer question={question} value={value} onChange={onChange} />
    </section>
  );
}
